export const credit_statement_entries_table = {
  empty_entries: "No credit activity yet.",

  col_date: "Date",
  col_description: "Description",
  col_amount: "Amount",
  col_running_balance: "Running balance",

  sale_of_part: "Sale of {part_type}",
  part_id_line: "Part ID: {part_number}",
  kind_withdrawal: "Withdrawal",
  kind_repair_spend: "Repair",
  kind_platform_cut: "Platform cut",
} as const;
